try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
    require("admin-lte");
    require("select2");
    require("daterangepicker");
    require("bootstrap-autocomplete");
    window.bsCustomFileInput = require("bs-custom-file-input");
} catch (e) {}
